import { useCallback } from "react"
import { IOpenPanel } from "../../../../../Interfaces/IPanel"
import { ITipoEquipoEdit } from "../../../../../Interfaces/ListaVerificacion/TipoEquipo/ITIpoEquipo"
import { UsePanelTipoEquipoEliminar } from "./UsePanelTipoEquipoEliminar"
import { PanelFooter } from "../../../../../components/Panel/PanelFooter"
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer"
import { Body1, makeStyles } from "@fluentui/react-components";
import { Warning24Filled } from "@fluentui/react-icons";
export interface IPanelTipoEquipoEliminar extends IOpenPanel {
  item: ITipoEquipoEdit

}
export const PanelTipoEquipoEliminar = (props: IPanelTipoEquipoEliminar) => {
  const styles = useStyles();
  const { request, setRequest, DeleteTipoEquipo, loading, reset, mensaje, status, loadprogress, contentShow } = UsePanelTipoEquipoEliminar(props)
  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Eliminar"
          texto2={"Salir"}
          //disableButton={disableForm}
          onClick={DeleteTipoEquipo}
          onDismiss={() => {
            reset()
          }}
        />
      </>
    ),
    [request]
  );
  return (
    <PanelDrawer
      isOpen={props.isOpen}
      onDismiss={reset}
      textHeader={"Eliminar Tipo de Equipo"}
      status={status}
      mensaje={mensaje}
      loading={loading}
      onRenderFooter={onRenderFooter}
    >

      <div hidden={loading}>
        {!mensaje && (
          <>
            {!loadprogress && (
              <>
                {contentShow && (
                  <>
                    <div className={styles.container}>
                      <div>
                        <Warning24Filled className={styles.warning} />
                      </div>
                      <div>
                        <Body1>
                          Este Tipo de Equipo será eliminada permanentemente, ¿Desea
                          eliminar el Tipo de Equipo: {props.item.codigo}?
                        </Body1>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>    </PanelDrawer>)
}

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    top: "100%",
    alignItems: "center",
  },

  warning: {
    color: " #eaa300",
    width: "60px",
    height: "60px",
  },
});